import { render, staticRenderFns } from "./MainSlogan.vue?vue&type=template&id=c9df505a&scoped=true&"
import script from "./MainSlogan.vue?vue&type=script&lang=ts&"
export * from "./MainSlogan.vue?vue&type=script&lang=ts&"
import style0 from "./MainSlogan.vue?vue&type=style&index=0&id=c9df505a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9df505a",
  null
  
)

export default component.exports